import { Nutrition } from './nutrition-model';
import { Profile } from './profile-menu';

export class PlanningProfile {
    Id: number;
    Name: string;
    PortionWeight: number;
    IsShowCal: number;
    IsCalcCal: number;
    Nutrition: Nutrition = new Nutrition();
    IsLocked: boolean;
    IsHidden: boolean;

    public static convertFromProfile(profile: Profile): PlanningProfile {
        const planningProfile = new PlanningProfile();
        planningProfile.Id = profile.Id_Profile;
        planningProfile.Name = profile.FullName;
        planningProfile.PortionWeight = profile.PortionWeight;
        planningProfile.IsShowCal = profile.IsShowCal;
        planningProfile.IsCalcCal = profile.IsCalcCal;

        const nutrition = new Nutrition();
        nutrition.CalPlan = profile.CalorificValuePerDay;
        nutrition.ProPlan = profile.ProteinsPerDay;
        nutrition.FatPlan = profile.FatsPerDay;
        nutrition.CarPlan = profile.CarbohydratesPerDay;
        planningProfile.Nutrition = nutrition;

        return planningProfile;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/planning-profile.ts